import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import { ExpandMore, ExpandLess, Edit, Delete } from '@mui/icons-material';
import {
  attributeTypeOptionsMap,
  functionTypeOptionsMap,
  isFunctionAttribute,
  type IAttribute,
} from '../../../Interfaces/ILegalTransactionMeasure';

export const AttributeCard = ({
  attribute,
  onMoveDown,
  onMoveUp,
  onEdit,
  onDelete,
  isLast,
  isFirst,
}: {
  attribute: IAttribute;
  onMoveDown: (attribute: IAttribute) => void;
  onMoveUp: (attribute: IAttribute) => void;
  onEdit: (attribute: IAttribute) => void;
  onDelete: (attributeId: number) => void;
  isLast: boolean;
  isFirst: boolean;
}) => {
  return (
    <Card variant='outlined'>
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          '&:last-child': {
            // Add this to remove bottom padding
            pb: 2,
          },
        }}
      >
        <Box display='flex' gap={2} alignItems='center'>
          <Typography variant='subtitle1'>
            {isFunctionAttribute(attribute)
              ? functionTypeOptionsMap[attribute.idSF]
              : attribute.Name}
          </Typography>
          <Chip
            size='small'
            label={
              attributeTypeOptionsMap[attribute.idMeasurementAttributeType]
            }
          />

          {!isFunctionAttribute(attribute) && attribute.Required && (
            <Chip size='small' label='Pflichtfeld' />
          )}
        </Box>
        <Box display='flex' gap={2}>
          {!(isFirst && isLast) && (
            <>
              <Tooltip title='Nach unten verschieben'>
                <IconButton
                  onClick={() => onMoveDown(attribute)}
                  disabled={isLast}
                >
                  <ExpandMore />
                </IconButton>
              </Tooltip>
              <Tooltip title='Nach oben verschieben'>
                <IconButton
                  onClick={() => onMoveUp(attribute)}
                  disabled={isFirst}
                >
                  <ExpandLess />
                </IconButton>
              </Tooltip>
            </>
          )}
          <IconButton onClick={() => onEdit(attribute)}>
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => onDelete(attribute.idMeasurementAttribute)}
          >
            <Delete />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};
